import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('businessDispatch.plateNumber'),
        dataIndex: "plateNumber",
        width: "80px",
        align: "center"
    },
    {
        title: i18n.t('edit'),
        dataIndex: "updateTruck",
        width: "80px",
        align: "center",
        scopedSlots: {customRender: 'updateTruck' }
    },
    // {   
    //     title: "ID",
    //     dataIndex: "id",
    //     width: "40px",
    //     align: "center"
    // },
    // {   
    //     title: "公司ID",
    //     dataIndex: "companyId",
    //     width: "120px",
    //     align: "center"
    // },

    // {
    //     title: "类型",
    //     dataIndex: "plateType",
    //     width: "80px",
    //     align: "center"
    // },
    // {
    //     title: "创建时间",
    //     dataIndex: "createdTime",
    //     width: "120px",
    //     align: "center"
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatedTime",
    //     width: "120px",
    //     align: "center"
    // }
];


export {
    columns,
}